/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Page404 } from '../../pages';
import { PublicLayout } from '../Layouts';

const securePrivate = (user, resource) => {
  if (
    user.grants &&
    user.grants.effectiveRoles &&
    user.grants.effectiveRoles.indexOf(resource) !== -1
  ) {
    return true;
  }
  return false;
};

const SecureRoute = ({ component: Component, user, resource, ...rest }) => (
  <Route
    {...rest}
    render={props => (user ? (
      securePrivate(user, resource) ? (
        <Component {...props} />
      ) : (
        <Page404 />
      )
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location }
        }}
      />
    ))}
  />
);

export const AppRoute = ({ publicAccess, layout: Layout, ...rest }) => {
  if (Layout === undefined) {
    Layout = PublicLayout;
  }
  return publicAccess ? (
    <Layout>
      <Route {...rest} />
    </Layout>
  ) : (
    <Layout>
      <SecureRoute {...rest} />
    </Layout>
  );
};
